class CreateOrganization {
	constructor(
		public readonly accountId: number,
		public readonly name: string,
		public readonly siret: string | null,
		public readonly headOfficeAddress: string | null,
		public readonly documentFooterMentions: string | null,
	) {
		Object.freeze(this);
	}

	// `accountId` is the route identifier: it is never echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			name: this.name,
			siret: this.siret,
			headOfficeAddress: this.headOfficeAddress,
			documentFooterMentions: this.documentFooterMentions,
		};
	}
}

export default CreateOrganization;
